export const SET_FLIGHT_INFO = 'SET_FLIGHT_INFO';
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
export const SET_SCENE = 'SET_SCENE';
export const SET_MODIFIED_FLIGHT_INFO = 'SET_MODIFIED_FLIGHT_INFO';
export const SET_MODIFIED_FLIGHT_INFO_PASSENGERS = 'SET_MODIFIED_FLIGHT_INFO_PASSENGERS';
export const SET_MODIFIED_FLIGHT_INFO_FLIGHTS = 'SET_MODIFIED_FLIGHT_INFO_FLIGHTS';
export const SET_MODIFIED_FLIGHT_INFO_ADDITIONAL_INFORMATION = 'SET_MODIFIED_FLIGHT_INFO_ADDITIONAL_INFORMATION';
export const SET_MODIFIED_FLIGHT_INFO_ATTACHMENTS = 'SET_MODIFIED_FLIGHT_INFO_ATTACHMENTS';

